import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { VisualizaDadosNfService } from './visualiza-dados-nf.service';
import { NotificationsService } from 'angular2-notifications';
import { EncriptyUtilService } from '../../../../../shared/services/encripty-util.service';
import { DocumentoHelper } from '../../../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-visualiza-dados-nf',
  templateUrl: './visualiza-dados-nf.component.html',
  styleUrls: ['./visualiza-dados-nf.component.scss']
})
export class VisualizaDadosNfComponent implements OnInit {

  //@Input() razaoSocial: string;
  //@Input() cnpj: string;
  //@Input() email: string;
  //@Input() telefone: string;

  //@ViewChild("card", null)

  //private card: ElementRef;
  public formVisualizarNF = null;
  public nome = null;
  public cpf = null;
  public inscricaoEstadual = null;
  public razaoSocial = null;
  public cnpj = null;
  public idComprador = null;
  public endereco = null;
  public teste = null;
  public cep = null;
  public tipoLogradouro = null;
  public tplogradouro = null;
  public logradouro = null;
  public complemento = null;
  public bairro = null;
  public numero = null;
  public localidade = null;
  public estado = null;
  public pessoaJuridica = false;
  public pessoaFisica = false;
  public customLogin = null;
  public cpfMaskAux = null;
  public cnpjMaskAux = null;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private service: VisualizaDadosNfService,
    private notificationService: NotificationsService,
    private encriptyService: EncriptyUtilService,
  ) {

    this.activatedRoute.queryParams.subscribe(params => {

      this.cnpj = this.encriptyService.decriptyBySecretKey(params.cnpj);
      this.idComprador = this.encriptyService.decriptyBySecretKey(params.idComprador);


      let register: any = {
        cnpj: this.normalizarCnpjCpfParaBackend(this.cnpj),
        idComprador: this.idComprador,
      };

      this.service.listSupplier(register, (response) => {

        const alvoNorm = this.normalizarCnpjCpfParaBackend(this.cnpj);

        for (let endereco of response) {

          const provNorm = this.normalizarCnpjCpfParaBackend(endereco.provider.cpfCnpj);

          if (alvoNorm !== '' && alvoNorm === provNorm) {

            if (endereco.provider.tipoFavorecido === 'PESSOA_JURIDICA') {

              this.pessoaJuridica = true;

              const cnpjRaw = this.normalizarCnpjCpfParaBackend(endereco.provider.cpfCnpj);
              this.cnpjMaskAux = cnpjRaw;
              this.formVisualizarNF.controls['cnpj'].setValue(cnpjRaw);
              this.formVisualizarNF.controls['razaoSocial'].setValue(endereco.provider.nomeRazaoSocial);
              this.formVisualizarNF.controls['cep'].setValue(endereco.endereco.cep);
              this.formVisualizarNF.controls['tplogradouro'].setValue(endereco.endereco.tipoLogradouro);
              this.formVisualizarNF.controls['logradouro'].setValue(endereco.endereco.logradouro);
              this.formVisualizarNF.controls['complemento'].setValue(endereco.endereco.complemento);
              this.formVisualizarNF.controls['bairro'].setValue(endereco.endereco.bairro);
              this.formVisualizarNF.controls['numero'].setValue(endereco.endereco.numero);
              this.formVisualizarNF.controls['localidade'].setValue(endereco.endereco.localidade);
              this.formVisualizarNF.controls['estado'].setValue(endereco.endereco.estado);
              this.formVisualizarNF.controls['inscricaoEstadual'].setValue(endereco.provider.inscricaoEstadual);

            } else {

              this.pessoaFisica = true;

              const cpfRaw = this.normalizarCnpjCpfParaBackend(endereco.provider.cpfCnpj);
              this.cpfMaskAux = cpfRaw;
              this.formVisualizarNF.controls['cpf'].setValue(cpfRaw);
              this.formVisualizarNF.controls['nome'].setValue(endereco.provider.nomeRazaoSocial);
              this.formVisualizarNF.controls['cep'].setValue(endereco.endereco.cep);
              this.formVisualizarNF.controls['tplogradouro'].setValue(endereco.endereco.tipoLogradouro);
              this.formVisualizarNF.controls['logradouro'].setValue(endereco.endereco.logradouro);
              this.formVisualizarNF.controls['complemento'].setValue(endereco.endereco.complemento);
              this.formVisualizarNF.controls['bairro'].setValue(endereco.endereco.bairro);
              this.formVisualizarNF.controls['numero'].setValue(endereco.endereco.numero);
              this.formVisualizarNF.controls['localidade'].setValue(endereco.endereco.localidade);
              this.formVisualizarNF.controls['estado'].setValue(endereco.endereco.estado);


            }
          }


        }
      }, (error) => this.notificationService.error("Endereço não localizado!"));


    });

    this.formVisualizarNF = this.formBuilder.group({

      nome: [null],
      cpf: [null],
      razaoSocial: [null],
      cnpj: [null],
      numero: [null],
      logradouro: [null],
      tplogradouro: [null],
      complemento: [null],
      bairro: [null],
      localidade: [null],
      estado: [null],
      cep: [null],
      inscricaoEstadual: [null],


    });

  }

  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  fecharForm() {

    this.location.back();

  }

  previousPage() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getCpfMascaraVisualiza(): string {
    const ctrl = this.formVisualizarNF && this.formVisualizarNF.get('cpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cpfMaskAux != null && String(this.cpfMaskAux).trim() !== ''
        ? this.cpfMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  getCnpjMascaraVisualiza(): string {
    const ctrl = this.formVisualizarNF && this.formVisualizarNF.get('cnpj');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjMaskAux != null && String(this.cnpjMaskAux).trim() !== ''
        ? this.cnpjMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
